import { Subscription } from 'rxjs';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BuildingService } from 'src/app/app/building/building.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { customValidators } from 'src/app/_helpers/customValidators';
import { globalHelper } from 'src/app/_helpers/global';
import { SelectColumns } from 'src/app/_models/select.model';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { Community, CommunityType } from '../community.model';
import { CommunityService } from '../community.service';
import { RawEditorOptions } from 'tinymce';
import { CommunityDescriptionAiComponent } from '../community-description-ai/community-description-ai.component';
import { DescriptionGenerated } from '../community-description-ai/community-ai.model';

@Component({
  selector: 'edit-add-community',
  templateUrl: './edit-community.page.html',
  styleUrls: ['./edit-community.page.scss'],
})
export class EditCommunityPage implements OnInit, OnDestroy {
  constructor(
    public communityServ: CommunityService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private router: Router,
    public buildingServ: BuildingService,
    public p: ThisPlatform,
    private alertController: AlertController,
    private translateService: TranslateService,
    private el: ElementRef,
    private headerServ: HeaderService,
    private modalCtrl: ModalController,
  ) {
    this.initForm();
  }
  subs: Subscription[] = [];
  form: FormGroup;
  fileData: File = null;
  attachmentFiles: File[] = [];
  validationError = false;
  typeId: number;
  type = CommunityType;
  idCommunity = 0;
  loading = true;
  disableSaveButton = false;
  showEditor: boolean = false;
  currentBuilding;
  deleteAttachments: boolean = false;
  hideBuildingDropdown: boolean = false;
  loadTinyMce: boolean = false;

  startDate: Date = new Date(new Date());
  endDate: Date = new Date(new Date());
  publishDate: Date = new Date(new Date());

  multipleFilesReadOnly: boolean = true;

  isError: boolean = false;
  errorStatus: number;

  textEditorConfig: RawEditorOptions;

  headerInit: HeaderModel = {
    title: '',
    showRightButtonsOnlyOnMobile: true,
    rightButtons: [],
  };

  selectColumns: SelectColumns[] = [
    {
      displayName: 'BUILDING.NAME',
      name: 'name',
      size: 5,
    },
    {
      displayName: 'BUILDING.DESCRIPTION',
      name: 'description',
      size: 7,
    },
  ];

  async ngOnInit() {
    setTimeout(() => {
      //obejście problemu z nieładowaniem się tinyMCE
      this.showEditor = false;
      this.loadTinyMce = true;
    });

    this.subs.push(
      this.route.paramMap.subscribe((paramMap) => {
        if (!paramMap.has('type')) {
          this.navCtrl.navigateBack('/app/community');
          return;
        }
        this.idCommunity = Number(paramMap.get('id'));
        this.typeId = Number(paramMap.get('type'));

        // Jeżeli chcemy dodać wydarzenie (typeId = 2), to dodaję walidację do dodatkowych pól.
        if (this.typeId == 2) {
          this.form.controls['startTime'].setValidators([Validators.required]);
          this.form.controls['endTime'].setValidators([Validators.required]);
          this.form.controls['localization'].setValidators([
            Validators.required,
            customValidators.trimValidator(),
          ]);

          this.form.setValidators([
            customValidators.dateValidator('startTime', 'endTime'),
          ]);
        }

        if (this.idCommunity === 0) {
          // new
          this.communityServ.community = new Community();
          this.initForm();

          this.headerInit.title = this.translateService.instant(
            'COMMUNITY.NEW_COMMUNITY'
          );

          this.form.patchValue({
            startTime: this.startDate,
            endTime: this.endDate,
          });
          this.multipleFilesReadOnly = false;
        } else {
          this.multipleFilesReadOnly = true;

          this.headerInit.title = this.translateService.instant(
            'COMMUNITY.DETAIL_COMMUNITY'
          );
          this.headerInit.rightButtons = [
            {
              iconName: 'trash',
              rolePermission: ['building.edit'],
              onClick: () => this.delete(),
            },
          ];
        }
      })
    );

    await this.buildingServ.loadBuildingsSync();

    if (this.buildingServ.buildings.length === 1) {
      this.hideBuildingDropdown = true;
      this.currentBuilding = this.buildingServ.buildings[0];
      this.form.patchValue({
        building: this.currentBuilding,
      });
    } else {
      this.hideBuildingDropdown = false;
    }

    this.subs.push(
      this.route.paramMap.subscribe((paramMap) => {
        if (!paramMap.has('type')) {
          this.navCtrl.navigateBack('/app/community');
          return;
        }
        this.loading = false;
        this.textEditorConfig = {
          height: 300,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 
            'preview', 'anchor', 'searchreplace', 'visualblocks', 'code',
            'fullscreen', 'insertdatetime', 'media', 'table',
            'help', 'wordcount',
          ],
          remove_linebreaks: true,
          language: `${this.translateService.currentLang}`,
          toolbar_mode: 'wrap',
          link_assume_external_targets: true,
          link_context_toolbar: true,
          toolbar:
            'formatselect | bold italic underline | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ',
          branding: false,
        };

        if (this.idCommunity !== 0) {
          this.communityServ.getCommunity(this.idCommunity).subscribe(
            (res: Community) => {
              this.communityServ.community = res;
              this.currentBuilding = this.buildingServ.buildings.filter((b) => {
                if (b.id === res.idBuilding) {
                  return b;
                }
              });
              this.initFormData();
            },
            (err) => {
              this.isError = true;
              this.errorStatus = err.status;
            }
          );
        }
      })
    );
  }
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
  }
  buildingChange(value) {
    this.communityServ.community.idBuilding = Number(value);
  }

  async delete() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );
    if (confirm) {
      this.subs.push(
        this.communityServ.deleteCommunity(this.idCommunity).subscribe(() => {
          this.refreshAndBack();
        })
      );
    }
  }

  initFormData() {
    this.startDate = this.communityServ.community.startTime;
    this.endDate = this.communityServ.community.endTime;

    this.form.patchValue({
      building: this.buildingServ.buildings.find(
        (a) => a.id === this.communityServ.community.idBuilding
      ),
      title: this.communityServ.community.title,
      description: this.communityServ.community.description,
      startTime: this.startDate,
      endTime: this.endDate,
      localization: this.communityServ.community.localization,
      itemImage: this.communityServ.community.image,
    });
  }
  initForm() {
    this.form = new FormGroup({
      building: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      title: new FormControl(null, {
        updateOn: 'blur',
        validators: [Validators.required, customValidators.trimValidator()],
      }),
      description: new FormControl(null, {
        updateOn: 'blur',
        validators: [
          Validators.maxLength(50000),
        ],
      }),
      startTime: new FormControl(null, {
        updateOn: 'blur',
      }),
      endTime: new FormControl(null, {
        updateOn: 'blur',
      }),
      publishDate: new FormControl(this.startDate, {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      localization: new FormControl(null, {
        updateOn: 'blur',
      }),
      itemImage: new FormControl(null, {
        updateOn: 'blur',
        validators: [
          customValidators.fileMaxSize(10000000),
          customValidators.fileFormat([
            'jpg',
            'png',
            'gif',
            'jfif',
            'pjpeg',
            'jpeg',
            'pjp',
          ]),
        ],
      }),
      sendNotification: new FormControl(false, {
        updateOn: 'blur',
      }),
    });
  }

  imageUploaded(file: File) {
    this.fileData = file;
    this.deleteAttachments = false;
  }

  imageRemoved($event) {
    this.fileData = null;
    this.deleteAttachments = true;
  }

  additionalImageUploaded(file: File) {
    this.attachmentFiles.push(file);
  }

  additionalImageRemoved(key: number) {
    if (this.attachmentFiles.length > key) {
      this.attachmentFiles.splice(key, 1);
    }
  }

  publicationDate(time) {
    this.publishDate = time;
    this.form.patchValue({
      publishDate: time,
    });
  }

  dateTimeChange(time, whichDate: string = 'start' || 'end') {
    if (whichDate == 'start') {
      this.startDate = time;
      this.form.patchValue({
        startTime: time,
      });
    } else {
      this.endDate = time;
      this.form.patchValue({
        endTime: time,
      });
    }
  }

  refreshAndBack() {
    this.communityServ.community = new Community();
    this.form.reset();
    switch (this.typeId) {
      case CommunityType.IntegrationTrip:
        this.router.navigateByUrl('app/integration-trip?section=1');
        break;
      case CommunityType.GoodPracticesList:
        this.router.navigateByUrl('app/practices-list');
        break;
      default:
        this.router.navigateByUrl('app/community?section=' + this.typeId);
        break;
    }
  }

  async Save() {
    this.disableSaveButton = true;

    if (
      this.form.value.description == null ||
      this.form.value.description.length <= 0
    ) {
      let confirm = await globalHelper.Alert(
        this.alertController,
        this.translateService,
        "COMMUNITY.POST_WITHOUT_TEXT"
      );

      if (!confirm) {
        this.disableSaveButton = false;
        return;
      }
    }

    if (!this.form.valid) {
      this.disableSaveButton = false;
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    const {
      title,
      description,
      localization,
      startTime,
      endTime,
      building,
      sendNotification,
      publishDate,
    } = this.form.value;

    const formData = new FormData();

    for (let key in this.attachmentFiles) {
      formData.append('files', this.attachmentFiles[key]);
    }

    this.fileData ? formData.append('file', this.fileData) : null;
    title ? formData.append('title', title) : null;
    this.typeId ? formData.append('type', JSON.stringify(this.typeId)) : null;
    building
      ? formData.append('idBuilding', JSON.stringify(building.id))
      : null;
    localization ? formData.append('localization', localization) : null;
    (description == null) ? "" : formData.append('description', description);
    startTime ? formData.append('startTime', this.startDate as any) : null;
    endTime ? formData.append('endTime', this.endDate as any) : null;
    publishDate
      ? formData.append('publishDate', this.publishDate as any)
      : null;

    this.deleteAttachments
      ? formData.append('deleteAttachments', 'true')
      : null;
    sendNotification
      ? formData.append(
        'sendNotification',
        this.form.value.sendNotification
          ? this.form.value.sendNotification
          : ''
      )
      : null;

    if (this.idCommunity === 0) {
      this.subs.push(
        this.communityServ.createCommunity(formData).subscribe(async (res) => {
          this.refreshAndBack();
          this.disableSaveButton = false;
        })
      );
    } else {
      this.subs.push(
        this.communityServ.updateCommunity(formData).subscribe(async (res) => {
          this.refreshAndBack();
          this.disableSaveButton = false;
        })
      );
    }
  }

  ionViewWillLeave() {
    this.showEditor = false;
    this.communityServ.community = new Community();
  }
  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }

  onTinyInit() {
    this.showEditor = true;
  }

  onGetContent(content) {
    if (content.event.content)
      this.form.value.description = content.event.content;
  }

  async generateAiContent() { 
    const modal = await this.modalCtrl.create({
      component: CommunityDescriptionAiComponent,
      animated: true,
      cssClass: 'add-edit-modal modal__desktop',
      componentProps: {}
    });

    modal.present();

    modal.onDidDismiss().then((data) => {
      const message: DescriptionGenerated = data.data?.message;
      if(message) {
        this.form.patchValue({
          description: message
        });
      }
    });
  }

  ngOnDestroy(): void {
    for (const e of this.subs) {
      e.unsubscribe();
    }
  }
}
